import { type StateCreator } from 'zustand';
import { type ApplicationStore, type State, type Store } from './types.ts';

export const createApplicationStore: (initialState: Partial<State>) => StateCreator<Store, [], [], ApplicationStore> =
  initialState => set => ({
    additionalCookiesAccepted: initialState.additionalCookiesAccepted,
    setAdditionalCookiesAccepted: (accepted: boolean) => {
      set(() => ({
        additionalCookiesAccepted: accepted,
      }));
    },
  });
